import React from "react";
import { IForm } from "../../../../types/form.type";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import { Controller, useForm } from "react-hook-form";
import { asyncPostData, asyncPutData } from "../../../../utils/httpRequests";
import ModalForm from "../../modal/ModalForm";
import { Stack } from "@mui/material";
import TextInput from "../../input/TextInput";
import SelectApiInput from "../../input/SelectApiInput";

const schema = yup.object({});

function FormDMXE({
  defaultValues,
  isEdit,
  apiCode,
  open,
  onClose,
  setLoad,
}: IForm) {
  const app = useSelector((state: any) => state.app.data);
  const token = useSelector((state: any) => state.auth.token);
  const { showAlert } = useAlertContext();
  const defaultData: { [key: string]: any } = {
    nha_xe: null,
    bien_so: "",
    loai_xe: null,
    mieu_ta: "",
  };
  const originData = defaultValues
    ? {
        ...defaultData,
        ...defaultValues,
        nha_xe: defaultValues?.nha_xe
          ? {
              ma_dt: defaultValues?.nha_xe || "",
              ten_dt: defaultValues?.ten_nha_xe || "",
            }
          : null,
        loai_xe: defaultValues?.type
          ? {
              _id: defaultValues?.type || "",
              name: defaultValues?.type_name || "",
            }
          : null,
      }
    : defaultData;

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { isSubmitting },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
    resolver: yupResolver(schema),
  });

  const handleReset = () => {
    reset(originData);
  };

  const generateDataPost = async (values: typeof defaultData) => {
    const { loai_xe, nha_xe, ...fields } = values;
    return {
      ...fields,
      type: loai_xe?._id,
      nha_xe: nha_xe?.ma_dt,
      ten_nha_xe: nha_xe?.ten_dt,
    };
  };

  const handleSave = async (values: typeof defaultData) => {
    const dataPost: { [key: string]: any } = await generateDataPost(values);
    let resp = null;
    if (isEdit) {
      resp = await asyncPutData({
        id: dataPost._id,
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    } else {
      resp = await asyncPostData({
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    }
    if (resp.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi lưu đối tượng",
      });
    } else {
      onClose();
      setLoad?.((prev: number) => prev + 1);
    }
  };

  const onSubmit = handleSubmit(handleSave);

  return (
    <ModalForm
      formWidth="500px"
      formTitle="xe"
      loading={isSubmitting}
      open={open}
      isEdit={isEdit}
      onClose={onClose}
      onSubmit={onSubmit}
      onReset={handleReset}
    >
      <Stack gap={2}>
        <Controller
          control={control}
          name="nha_xe"
          render={({ field: { value, onChange } }) => {
            return (
              <SelectApiInput
                label="Nhà xe"
                labelWidth="30%"
                placeholder="Chọn nhà xe"
                apiCode="dmnhaxe"
                selectTitle="Chọn nhà xe"
                placeholderSearch="Tìm theo mã, tên nhà xe"
                checkEqual={(value, option) => value?.ma_dt === option?.ma_dt}
                getOptionLabel={(option) => option.ten_dt}
                searchFields={["ma_dt", "ten_dt"]}
                value={value}
                onChange={onChange}
              />
            );
          }}
        />
        <TextInput
          label="Biển số"
          labelWidth="30%"
          placeholder="Nhập biển số"
          name="bien_so"
          register={register}
        />
        <Controller
          control={control}
          name="loai_xe"
          render={({ field: { value, onChange } }) => {
            return (
              <SelectApiInput
                label="Loại xe"
                labelWidth="30%"
                placeholder="Chọn loại xe"
                apiCode="dmloaixe"
                selectTitle="Chọn loại xe"
                placeholderSearch="Tìm theo tên loại xe"
                checkEqual={(value, option) => value?._id === option?._id}
                getOptionLabel={(option) => option.name}
                searchFields={["name"]}
                value={value}
                onChange={onChange}
              />
            );
          }}
        />
        <TextInput
          label="Miêu tả"
          labelWidth="30%"
          placeholder="Nhập miêu tả xe"
          name="mieu_ta"
          register={register}
        />
      </Stack>
    </ModalForm>
  );
}

export default FormDMXE;
